module.exports = __webpack_public_path__ + "media/images/bg_header_sp-aa1a5c9fbb99be66bac2c40f776e6f12.jpg";